import React from "react";
import { useState, forwardRef, useImperativeHandle, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { Company } from "../../types";

type AddressProps = {
    company: Company
    children?: React.ReactNode
    region: string
    city: string
    street: string
    house: string
    onRegionChange: (value: string) => void
    onCityChange: (value: string) => void
    onStreetChange: (value: string) => void
    onHouseChange: (value: string) => void
    onDataChange: (value: boolean) => void
}

function Address({company, children, region, city, street, house, onRegionChange, onCityChange, onStreetChange, onHouseChange, onDataChange} : AddressProps, ref: any) {
    const [regionDirty, setRegionDirty] = useState(false);
    const [regionError, setRegionError] = useState('');

    const [cityDirty, setCityDirty] = useState(false);
    const [cityError, setCityError] = useState('');

    const [streetDirty, setStreetDirty] = useState(false);
    const [streetError, setStreetError] = useState('');

    const [houseDirty, setHouseDirty] = useState(false);
    const [houseError, setHouseError] = useState('');

    const blurHandler = (e: React.FocusEvent<HTMLInputElement>) => {
        switch (e.target.name) {
            case 'area':
                setRegionDirty(true)
                break;
            case 'city':
                setCityDirty(true)
                break;
            case 'street':
                setStreetDirty(true)
                break;
            case 'house':
                setHouseDirty(true)
                break;
        }
    }

    const regionHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        onRegionChange(e.target.value);
        onDataChange(true);
        setRegionError('');
    }

    const cityHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        onCityChange(e.target.value);
        onDataChange(true);
        setCityError('');
    }

    const streetHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        onStreetChange(e.target.value);
        onDataChange(true);
        setStreetError('');
    }

    const houseHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        onHouseChange(e.target.value);
        onDataChange(true);
        setHouseError('');
    }

    const checkErrors = () => {
        return (regionError || cityError || streetError || houseError);
    }

    useImperativeHandle(ref, () => ({ checkErrors }));

    return (
        <>
            <h2 style={{ marginBottom: '20px', marginTop: '24px' }}> Адрес офиса</h2>
            <div style={{maxWidth: '416px', marginBottom: '20px'}}>
                <div className="pair-input">
                    <div className="form-group first-in-pair">
                        <Form.Label> Область </Form.Label>
                        <Form.Control type="text" placeholder="" name='area'
                            value={region} onBlur={blurHandler} onChange={regionHandler} />
                        {(regionDirty && regionError) && <p className="error-alert">{regionError}</p>}
                    </div>
                    <div className="form-group second-in-pair">
                        <Form.Label> Город </Form.Label>
                        <Form.Control type="text" placeholder="" name='city'
                            value={city} onBlur={blurHandler} onChange={cityHandler} />
                        {(cityDirty && cityError) && <p className="error-alert">{cityError}</p>}
                    </div>
                </div>
                <div className="pair-input">
                    <div className="form-group first-in-pair">
                        <Form.Label> Улица </Form.Label>
                        <Form.Control type="text" placeholder="" name='street'
                            value={street} onBlur={blurHandler} onChange={streetHandler} />
                        {(streetDirty && streetError) && <p className="error-alert">{streetError}</p>}
                    </div>
                    <div className="form-group second-in-pair">
                        <Form.Label> Дом </Form.Label>
                        <Form.Control type="text" placeholder="" name='house'
                            value={house} onBlur={blurHandler} onChange={houseHandler} />
                        {(houseDirty && houseError) && <p className="error-alert">{houseError}</p>}
                    </div>
                </div>
            </div>
            {children}
        </>
    )
}

export default forwardRef(Address);